var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1890_90",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0026 0.833252C2.7026 0.833252 0.835938 2.69992 0.835938 4.99992C0.835938 7.29992 2.7026 9.16659 5.0026 9.16659C7.3026 9.16659 9.16927 7.29992 9.16927 4.99992C9.16927 2.69992 7.3026 0.833252 5.0026 0.833252ZM5.0026 5.41659C4.77344 5.41659 4.58594 5.22909 4.58594 4.99993V3.33326C4.58594 3.10409 4.77344 2.91659 5.0026 2.91659C5.23177 2.91659 5.41927 3.10409 5.41927 3.33326V4.99993C5.41927 5.22909 5.23177 5.41659 5.0026 5.41659ZM4.58594 6.24991V7.08324H5.41927V6.24991H4.58594Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1890_90)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#F9123B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSignal);
export default __webpack_public_path__ + "static/media/errorSignal.ac584ab02d9c61c37432c025dd0a1e86.svg";
export { ForwardRef as ReactComponent };